import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use(config => {
    const token = localStorage.getItem('cloudpet-admin-token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const formatPrice = (price) => {
    return new Intl.NumberFormat('es-AR', {
        style: 'currency', currency: 'ARS',
        minimumFractionDigits: 0, maximumFractionDigits: 0,
    }).format(price);
};

export const getSessionId = () => {
    let sid = localStorage.getItem('cloudpet-session');
    if (!sid) {
        sid = 'sess_' + Math.random().toString(36).substr(2, 12) + Date.now().toString(36);
        localStorage.setItem('cloudpet-session', sid);
    }
    return sid;
};
